import AlternateSizeGatsbyImage from '@root/gatsby-contentful-core/src/components/alternate-size-gatsby-image';
import GoingPlacesFormFlow from '@root/joinroot.com/src/components/going-places/going-places-form-flow';
import LinkButton from '@root/gatsby-contentful-core/src/components/buttons/link-button';
import LinkButtonModel from '@root/gatsby-contentful-core/src/models/link-button';
import Modal, { MODAL_WIDTH } from '@root/gatsby-contentful-core/src/components/modal';
import PropTypes from '@root/vendor/prop-types';
import React, { useState } from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { H1Display, Subhead } from '@root/gatsby-contentful-core/src/components/text';
import { getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

export default function GoingPlacesSection({ anchor, sectionSpacing = {} }) {
  const { trackClick, trackEvent } = useAnalytics('GOING_PLACES_SECTION', true);
  const [isModalShowing, setIsModalShowing] = useState(false);

  const sectionSpacingStyles = {
    paddingTop: sectionSpacing.top / 1.25,
    paddingBottom: sectionSpacing.bottom / 1.25,
    ...Responsive.md({
      paddingTop: sectionSpacing.top,
      paddingBottom: sectionSpacing.bottom,
    }),
  };

  const { desktopImg, mobileImg } = useStaticQuery(graphql`
    query {
      desktopImg: file(relativePath: {eq: "going-places/going-places-phoenix.jpg"}) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH, quality: 70)
        }
      }
      mobileImg: file(relativePath: {eq: "going-places/going-places-phoenix.jpg"}) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
        }
      }
    }
  `);

  return (
    <section
      css={[styles.section, sectionSpacingStyles]}
      id={anchor}
    >
      <div css={styles.wrapImage}>
        <AlternateSizeGatsbyImage
          desktop={getImage(desktopImg)}
          imageAltText={''}
          loading={'eager'}
          mobile={getImage(mobileImg)}
          styles={{ height: '100%' }}
        />
      </div>
      <div css={styles.wrapContent}>
        <div css={styles.containerContent}>
          <H1Display css={styles.headline}>Something’s coming your way, Phoenix.</H1Display>
          <Subhead css={styles.subhead}>Be among the first to hear about a special upcoming offer for Phoenix-area drivers by signing up here.</Subhead>
          <div css={styles.buttonWrapper}>
            <LinkButton
              buttonStyles={styles.button}
              onClick={() => {
                trackClick('GET_NOTIFIED_BUTTON');
                setIsModalShowing(true);
              }}
              to={'#'}
              type={LinkButtonModel.types.PRIMARY}
            >
              Don’t miss out
            </LinkButton>
          </div>
        </div>
      </div>
      <Modal
        isShowing={isModalShowing}
        modalWidth={MODAL_WIDTH.Small}
        name={'going-places-modal'}
        onClose={() => setIsModalShowing(false)}
      >
        {isModalShowing && (
          <GoingPlacesFormFlow
            onClose={() => setIsModalShowing(false)}
            trackClick={trackClick}
            trackEvent={trackEvent}
          />
        )}
      </Modal>
    </section>
  );
}

GoingPlacesSection.propTypes = {
  anchor: PropTypes.string,
  sectionSpacing: PropTypes.shape({
    bottom: PropTypes.number,
    top: PropTypes.number,
  }),
};

const styles = StyleSheet.create({
  section: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    padding: '5%',
  },

  wrapImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    overflow: 'hidden',
    filter: 'brightness(80%)',
  },

  wrapContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4rem',

    ...Responsive.lg({
      paddingRight: '20rem',
    }),
    ...Responsive.xl({
      height: '40vw',
    }),
  },

  containerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 900,
    padding: '40px 20px',
    textAlign: 'center',

    ...Responsive.md({
      alignItems: 'flex-start',
      textAlign: 'left',
    }),
  },

  headline: {
    color: Colors.white(),
  },

  subhead: {
    margin: '16px 0 16px',
    color: Colors.white(),
    textShadow: '0 0 20px rgba(0,0,0,0.6)',
  },

  buttonWrapper: {
    display: 'flex',
    marginTop: '30px',
    alignSelf: 'center',

    ...Responsive.md({
      alignSelf: 'flex-start',
    }),

  },
});
